module.exports = __webpack_public_path__ + "media/images/icons/user-528a12a7c6e4fca985c4ed3476bf482b.svg";